<template>
<!-- 顶部导航栏 -->
    <section class="nav">
        <div class="w-1200 flex a-between m0auto">
            <img style="margin-top:13px;width:120px;height:36px;cursor: pointer;" :src="logoUrl" @click="$router.push('/')">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" @click="$router.push('/')">首页</el-menu-item>
            <el-submenu index="2">
                <template slot="title">解决方案</template>
                <el-menu-item index="2-1"  @click="$router.push('/phoneSolution')">手机行业</el-menu-item>
                <el-menu-item index="2-2" @click="$router.push('/petSolution')">宠物行业</el-menu-item>
                <el-menu-item index="2-3" @click="$router.push('/householdSolution')">家电行业</el-menu-item>
                <el-menu-item index="2-4" @click="$router.push('/otherSolution')">其他行业</el-menu-item>
            </el-submenu>
            <el-menu-item index="3" @click="$router.push('/customer')">客户及合作案例</el-menu-item>
            <el-menu-item index="4" @click="$router.push('/aboutUs')">走进中保</el-menu-item>
            </el-menu>
        </div>
    </section>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      logoUrl: require('@/assets/logo1.png')
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/variable.scss";
.nav{
    position:absolute;
    top:10px;
    left: 0;
    width: 100%;
    z-index: 99;
    .el-menu{
        background: transparent;
        border-bottom: none;
    }
    .el-menu--horizontal>.el-menu-item.is-active{
        border-bottom: 2px solid #fff;
        color: #fff;
    }
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
        background-color: transparent;
        color: #fff;
        &::after{
            background: #fff;
            width: 100%;
        }
    }
    .el-menu--horizontal>.el-submenu .el-submenu__title{
        color: #ccc;
        font-size: 16px;
        &::after{
            position: absolute;
            left: 0;
            width: 0;
            bottom: -2px;
            height: 2px;
            background: transparent;
            content: " ";
            -webkit-transition: width .5s;
            transition: width .5s;
        }

    }
    .el-menu--horizontal>.el-menu-item{
        color: #ccc;
        font-size: 16px;
        &::after{
            position: absolute;
            left: 0;
            width: 0;
            bottom: -2px;
            height: 2px;
            background: transparent;
            content: " ";
            -webkit-transition: width .5s;
            transition: width .5s;
        }
    }
    .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
        color: #fff;
        &::after{
            background: #fff;
            width: 100%;
        }
    }
    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
        border-bottom: 2px solid #fff;
    }
    .el-submenu__title i{
        color: #ccc;
    }
    .el-menu-item{
       margin: 0 38px;
       padding: 0;
    }
    .el-submenu__title{
        margin: 0 38px;
        padding: 0;
    }
    .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
        display: none;
    }
}
.el-menu--horizontal {
    .el-menu--popup{
        min-width: 145px;
        padding: 10px 0;
    }
    .el-menu-item{
        text-align: center;
    }
}
</style>
